<template>
<div class="container login">
    <!-- Outer Row -->
    <div class="row justify-content-center">
        <div class="col-xl-9 col-lg-12 col-md-9">
            <div class="card o-hidden border-0 shadow-lg my-5">
                <div class="card-body p-0">
                    <!-- Nested Row within Card Body -->
                    <div class="row">
                        <div class="col-lg-6 bg-login-image bg-primary">
                            <h1 style="font-weight:bold" class="h1 text-bold text-white mb-4">PLANET</h1>
                        </div>
                        <div class="col-lg-6">
                            <div class="p-4">
                                <div class="text-center">
                                    <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
                                </div>
                                <form class="user" action autocomplete="off" @submit.prevent="login()">
                                    <div class="form-group">
                                        <input type="email" class="form-control form-control-user" id="exampleInputEmail" name="email" v-model="email" required aria-describedby="emailHelp" placeholder="Enter Email Address..." />
                                    </div>
                                    <div class="form-group position-relative">
                                        <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-user" id="exampleInputPassword" name="password" v-model="password" placeholder="Password" required />
                                        <button type="button" class="btn btn-outline-secondary position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%);border:none" @click="togglePasswordVisibility">
                                            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                        </button>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox small">
                                            <input v-model="rememberMe" type="checkbox" class="custom-control-input" id="customCheck" />
                                            <label class="custom-control-label" for="customCheck">Remember Me</label>
                                        </div>
                                    </div>
                                    <div v-if="error" class="alert alert-danger">{{cleanError(error)}}</div>
                                    <button type="submit" id="sendlogin" class="btn btn-primary btn-user btn-block">Login</button>
                                    <!--<hr>
                    <a href="index.html" class="btn btn-google btn-user btn-block">
                      <i class="fab fa-google fa-fw"></i> Login with Google
                    </a>
                    <a href="index.html" class="btn btn-facebook btn-user btn-block">
                      <i class="fab fa-facebook-f fa-fw"></i> Login with Facebook
                    </a>-->
                                </form>
                                <hr />
                                <div class="text-center">
                                    <router-link class="small" to="/forgot">Forgot/Reset Password?</router-link>
                                </div>
                                <!--<div class="text-center">
                    <a class="small" href="register.html">Create an Account!</a>
                  </div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    firebaseAuth
} from "../main";

export default {
    name: 'Login',
    data: function () {
        return {
            email: '',
            password: '',
            rememberMe: true,
            error: null,
            showPassword: false
        }
    },
    methods: {
        cleanError(err){
            return err.replace("auth/wrong-password ","");
        },
        login() {
            const t = this;

            t.error = null;
            firebaseAuth().setPersistence(this.rememberMe ? firebaseAuth.Auth.Persistence.LOCAL : firebaseAuth.Auth.Persistence.SESSION)
                .then(function () {
                    // Existing and future Auth states are now persisted in the current
                    // session only. Closing the window would clear any existing state even
                    // if a user forgets to sign out.
                    // ...
                    // New sign-in will be persisted with session persistence.
                    return firebaseAuth().signInWithEmailAndPassword(t.email, t.password).then((user) => {
                        console.log("logged", user);
                        if (user.user.email === 'auckland@itrecycla.co.nz' || user.user.email === 'wellington@itrecycla.co.nz'){
                            t.$router.replace('/in')
                             //is inward goods receiver
                        }else if(t.$route.query.from){
                            t.$router.replace(t.$route.query.from)
                        }else{
                            t.$router.replace('/dashboard')
                        }

                    }).catch((err) => {
                        t.error =  err.code + " " + err.message;
                    });
                })
                .catch(function (err) {
                    t.error = err.code + " " + err.message;
                });

        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
    }
}
</script>

<style scoped>
/* Ensure the password input and toggle button are properly aligned */
.form-group.position-relative {
    position: relative;
}

.btn-outline-secondary {
    padding: 0.25rem 0.5rem;
    line-height: 1;
}

.btn-outline-secondary i {
    font-size: 1rem;
}
</style>